angular.module('TetherApp').factory('launchpadService', [
    '$http',
    function ($http) { return {}; }
]);
